//--------------------------------
// indices of substring in string
//--------------------------------
export default function indicesOfSubstring(str, substr) {
  // console.log("----------------------")
  // console.log("IN indicesOfSubstring")

  let indices = [];
  for (let i = 0; i < str.length; i++) {
    if (str[i] == substr) {
      indices.push(i);
    }
  }
  return indices;
}
